<div class="flex flex-col gap-6">
  <span class="text-xl font-bold">Datos de entrada</span>

  <div class="grid grid-cols-2 gap-4">
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('personalSelectedDataType')"
        (change)="reviewFields.toggleField('personalSelectedDataType')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Datos personales tratados por el sistema de IA</span>
          <app-tooltip
            *ngIf="
              reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('personalSelectedDataType')
            "
            class="-mt-2"
            [description]="previousReviewText('personalSelectedDataType')"
            tipeIcon="info" />
        </div>
        <span class="text-md">
          {{ personalSelectedDataTypeLabel(project?.personalSelectedDataType) }}
        </span>
      </div>
    </div>

    <div
      *ngIf="project?.personalSelectedDataType !== 'no'"
      class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('categoryDataPersonalSelected')"
        (change)="reviewFields.toggleField('categoryDataPersonalSelected')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Categoría de datos personales tratados</span>
          <app-tooltip
            *ngIf="
              reviewMode &&
              showPreviousReviewIndicators &&
              reviewFields.hasPreviousReview('categoryDataPersonalSelected')
            "
            class="-mt-2"
            [description]="previousReviewText('categoryDataPersonalSelected')"
            tipeIcon="info" />
        </div>
        <div class="text-md mt-2">
          <div *ngFor="let cat of project?.categoryDataPersonalSelected">
            {{ categoryMap[cat] || cat }}
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="project?.personalSelectedDataType !== 'no'"
      class="col-span-2 flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('biometricData')"
        (change)="reviewFields.toggleField('biometricData')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Tratamiento de datos biométricos</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('biometricData')"
            class="-mt-2"
            [description]="previousReviewText('biometricData')"
            tipeIcon="info" />
        </div>
        <span class="text-md">
          {{ project?.biometricData || '-' }}
        </span>
      </div>
    </div>
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('RAT')"
        (change)="reviewFields.toggleField('RAT')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Actividad de tratamiento publicada en el RAT</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('RAT')"
            class="-mt-2"
            [description]="previousReviewText('RAT')"
            tipeIcon="info" />
        </div>
        <span class="text-md">
          {{ project?.RAT || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('eipd')"
        (change)="reviewFields.toggleField('eipd')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">
            Evaluación de impacto en la protección de datos personales (EIPD)
          </span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('eipd')"
            class="-mt-2"
            [description]="previousReviewText('eipd')"
            tipeIcon="info" />
        </div>
        <span class="text-md">
          {{ project?.eipd === 'No realizada' ? project?.eipd : (project?.eipd! | spanishDate) }}
        </span>
      </div>
    </div>

    <div
      *ngIf="project?.eipd && project?.eipd !== 'No realizada'"
      class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('csvEipd')"
        (change)="reviewFields.toggleField('csvEipd')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">CSV</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvEipd')"
            class="-mt-2"
            [description]="previousReviewText('csvEipd')"
            tipeIcon="info" />
        </div>
        <span class="text-md">
          {{ project?.csvEipd || '-' }}
        </span>
      </div>
    </div>
  </div>
</div>
